import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, Box } from '@mui/material';
import Flex from 'ui/Flex/Flex';

const EchelonHypothesis = (): React.ReactElement => {
    const { t } = useTranslation();

    return (
        <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            sx={{ marginBottom: '1rem' }}
        >
            <Box display="flex" alignItems="center">
                <Typography variant="body1SemiBold">
                    {t(
                        'humanResources.simulation.duplicateSimulation.thirdStep.echelonsRaise',
                    )}
                </Typography>
            </Box>

            <Flex>
                <Typography variant="body2">
                    {t(
                        'humanResources.simulation.duplicateSimulation.thirdStep.willBeRecalculated',
                    )}
                </Typography>
            </Flex>
        </Box>
    );
};

export default EchelonHypothesis;
